import Alert from "@liberetech/design-system/Alert";
import Section from "@liberetech/design-system/Section";
import { GetServerSideProps } from "next";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { useDevice } from "components/Context/PageContext";
import { useSession } from "components/Context/SessionContext";
import FormFieldset from "components/FormFieldset/FormFieldset";
import Loader from "components/Loader/Loader";
import { identityClient } from "lib/client/identity";
import { useLanguage, useTranslation } from "lib/i18n/client";
import { captureError } from "lib/logger";
import withDirectChannelCommonProps from "lib/withDirectChannelCommonProps";

import styles from "./logout.module.css";

const Logout: React.FC = () => {
  const { t } = useTranslation("logout");
  const { query, replace } = useRouter();
  const { notifyNativeApp } = useDevice();
  const [error, setError] = useState<string | null>(null);
  const { refresh: refreshSession } = useSession();
  const lang = useLanguage();
  const doLogout = async () => {
    try {
      await identityClient(lang).logout();
      notifyNativeApp("logout");
      await refreshSession();
      replace(
        `/login${
          Object.keys(query).length > 0
            ? `?${new URLSearchParams(
                query as Record<string, string>,
              ).toString()}`
            : ""
        }`,
      );
    } catch (err) {
      captureError(err);
      setError("unknown");
    }
  };

  useEffect(() => {
    doLogout();
  }, []);
  return (
    <Section className={styles.content} background="contrast">
      <div className="grid">
        <div className={styles.formContent}>
          {!error && (
            <FormFieldset title={t("sectionTitle")} oneColumn>
              <Loader />
              <p>{t(`loggingOut`)}</p>
            </FormFieldset>
          )}
          {error && (
            <Alert type="error">{t("common:validation.unknownError")}</Alert>
          )}
        </div>
      </div>
    </Section>
  );
};

export const getServerSideProps: GetServerSideProps =
  withDirectChannelCommonProps(async () => {
    return {
      props: {
        trackingContext: {
          page_type: "logout",
        },
      },
    };
  });

export default Logout;
